import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) => createStyles({
  'text-initial': {
    textTransform: 'initial',
  },
  'dialog-para-text': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '138%',
    color: '#333333',
    margin: '3px auto 17px',
  },
  testLabel:{
    fontSize: 16,
    color: '#666',
    fontWeight: 400
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRightSub1: theme.spacing.unit,
  },
  menu: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  createCoursePlanCont:{
    backgroundColor: '#fff',
    padding: '25px 22px',
    position: 'relative'
  },
  phaseFooterFixed: {
    "&>div": {
      height:'initial',
      margin: 0,
      "& div:nth-of-type(2)": {
        position: "fixed",
        width: "calc(100% - 84px)",
        height: 76,
        right: 0,
        display: "flex",
        alignItems: "center",
        padding: "0 30px",
        left: "initial",
        boxShadow: "8px -2px 10px rgba(0, 0, 0, 0.12)",        
      },
      "&>div:nth-of-type(1)": {
        display: "none",       
      },
    },
  },
  examContainer: {
    display: "flex",
    flexDirection: "column",
    '& p:nth-of-type(1)':{
      display: 'flex',
    }
  },
  examDate: {
    paddingLeft: 25,
  },
  tableContainer:{
    backgroundColor: '#fff',
    '& td':{
      padding: '0 10px',
      border: 'none',
      '&:last-of-type':{
        paddingRight: 0,
      }
    },
    '& th':{
      border: 'none',
      textAlign: 'left',
      padding: '4px 32px 4px 15px',
    },
    '& thead':{
      '& tr':{
        height: '36px'
      }
    }
  },
  tableWrapper:{
    overflow: 'auto',    
    '& table':{
      minWidth: 1020,
    },
    '&::-webkit-scrollbar': {
      display: 'none'
    },
  },
  addMoreContainer:{
    paddingTop: 15,
    // paddingBottom: 100,
    paddingRight: 30,
    backgroundColor: '#fff',
  },
  tdstyle:{
    '&>div':{
      marginTop: '0 !important',
      '&>div':{
        height: '44px',
      }
    }
  },
  checkboxAlign:{
    '&>:first-child':{
      marginTop: '-7px'
    }
  },
  MainHeading:{
    fontSize: 24,
    color: '#333',
    lineHeight: '33px'
  },
  courseDuration:{
    fontSize: 16,
    lineHeight: '20px',
    color: '#666',
    marginBottom: 10
  },
  weekFormatSelect:{
    '&>:first-child':{
      '&::before':{
        display: 'none'
      },
      '&>:first-child':{
        padding: '0 0 0 5px',
        '& select':{
          background: 'transparent'
        }
      }
    },
  },
  countPhase:{
    fontSize: 16,
    lineHeight: '22px',
    color: '#333'
  },
  boldData:{
    fontWeight: 600
  },
  manageCloseIcon:{
    position: "absolute",
    right:5,
    top:11,
  },
  marginL10:{
    marginLeft: 10,
  },
  weight600:{
    fontWeight: 600,
  },
  manageInputWidth:{
    '&>:first-child':{
      '&>:first-child':{
        width: 167,
      },
    },
    '& input':{
      width: 167,
    },
    '& select':{
      width: 167,
    }
  },
  scrollHide:{
    overflow: 'auto',
    // maxWidth: 300,
    '&::-webkit-scrollbar': {
      display: 'none'
    },
  },
  setButton:{
    position: 'absolute',
    right: '20px',
    top: 20,
  },
  tabArea:{
    backgroundColor: '#fff',
  },
  createCoursePlanContainer:{
    backgroundColor: '#fff',
  },
  blockContainer:{
    paddingBottom: 100,
    backgroundColor: '#fff',
    '& label':{
      marginRight: 20,
    },
  },
  blockTitle:{
    fontSize: 20,
    fontWeight: 400,
    paddingLeft: 17,
    paddingBottom: 5,
  },
  phaseToggle: {
    fontSize: 16,
    fontWeight: 400,
    paddingRight: '0 !important',
    '& span':{
      display: "flex",
      alignItems: "center",
      whiteSpace: "nowrap",
    },
    '& .infoContainer img': {
      width: '16px',
    }
  }
  });

export { styles };